import React, { useState } from "react";
import { passwordError, PASSWORD_HINT } from "@/lib/passwordPolicy";
import { KeyRound, Loader2, LogOut } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

const INPUT = "w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm text-slate-900 dark:text-white outline-none focus:border-emerald-500";

export function ForcePasswordChange() {
    const { user, logout } = useAuth() || {};
    const [f, setF] = useState({ current: "", next: "", confirm: "" });
    const [busy, setBusy] = useState(false);
    if (!user?.must_change_password) return null;

    const submit = async (e) => {
        e.preventDefault();
        if (passwordError(f.next)) { toast.error(passwordError(f.next)); return; }
        if (f.next !== f.confirm) { toast.error("Yeni şifreler eşleşmiyor"); return; }
        setBusy(true);
        try {
            await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
            toast.success("Şifreniz güncellendi");
            window.location.reload();
        } catch (err) {
            toast.error(err.response?.data?.detail || "Şifre değiştirilemedi");
        } finally { setBusy(false); }
    };

    return (
        <div className="fixed inset-0 z-[100] bg-slate-950/80 backdrop-blur-sm flex items-center justify-center p-4" data-testid="force-password-modal">
            <form onSubmit={submit} className="w-full max-w-md bg-white dark:bg-slate-900 rounded-2xl shadow-2xl p-7 space-y-3">
                <div className="h-12 w-12 rounded-xl bg-amber-100 text-amber-600 flex items-center justify-center"><KeyRound className="h-6 w-6" /></div>
                <h2 className="text-xl font-bold text-slate-900 dark:text-white">Yeni şifrenizi belirleyin</h2>
                <p className="text-sm text-slate-600 dark:text-slate-400">Güvenliğiniz için geçici şifrenizi değiştirmeniz gerekiyor. Devam etmek için yeni bir şifre belirleyin.</p>
                <input data-testid="force-pw-current" type="password" value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} placeholder="Geçici (mevcut) şifre" className={INPUT} required />
                <input data-testid="force-pw-new" type="password" value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} placeholder={`Yeni şifre (${PASSWORD_HINT})`} className={INPUT} required />
                <input data-testid="force-pw-confirm" type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} placeholder="Yeni şifre (tekrar)" className={INPUT} required />
                <button data-testid="force-pw-submit" disabled={busy} className="w-full py-3 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-white font-bold text-sm inline-flex items-center justify-center gap-2 disabled:opacity-60">
                    {busy && <Loader2 className="h-4 w-4 animate-spin" />} Şifremi Güncelle
                </button>
                <button type="button" data-testid="force-pw-logout" onClick={() => { logout(); window.location.assign("/h/login"); }} className="w-full py-2 text-xs font-semibold text-slate-500 inline-flex items-center justify-center gap-1"><LogOut className="h-3.5 w-3.5" /> Çıkış yap</button>
            </form>
        </div>
    );
}
